module.exports = __webpack_public_path__ + "static/media/tour-virtual2.373db10f.svg";